//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
export default {
  props: ['footerShow'],
  name: 'footerBar',
  data() {
    return {
      thisShow: false,
      items: [
        {
          name: '首页',
          url: '/',
          path: '',
          icon1: require('../assets/footerbarimg/home.png'),
          icon2: require('../assets/footerbarimg/home2.png')
        },
        {
          name: '技师',//技师
          url: '',//zhiyue
          path: '',
          icon1: require('../assets/footerbarimg/zhiyue.png'),
          icon2: require('../assets/footerbarimg/zhiyue2.png')
        },
        {
          name: '订单',
          url: '/allorder',
          path: '',
          icon1: require('../assets/footerbarimg/order.png'),
          icon2: require('../assets/footerbarimg/order2.png')
        },
        {
          name: '我的',
          path: '/my',
          url: '',
          icon1: require('../assets/footerbarimg/my.png'),
          icon2: require('../assets/footerbarimg/my2.png')
        }
      ]
    }
  },
  created() {
    window.setTimeout(() => {
      this.thisShow = true
      var footerShow = this.footerShow;
      if (footerShow && footerShow.name == 'fenlei') {
        var items = [
          {
            name: '首页',
            url: '/detailspage',
            icon1: require('../assets/footerbarimg/home.png'),
            icon2: require('../assets/footerbarimg/home2.png'),
            path: '/detailspage?id=' + footerShow.id + '&footerShow=' + JSON.stringify(footerShow),
          },
          {
            name: '分类',
            path: '/classification?serviceId=' + footerShow.id + '&footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/fenlei.png'),
            icon2: require('../assets/footerbarimg/fenlei2.png'),
            url: '/classification'
          },
          {
            name: '订单',
            path: '/allorder?footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/order.png'),
            icon2: require('../assets/footerbarimg/order2.png'),
            url: '/allorder'
          },
          {
            name: '我的',
            path: '/my?footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/my.png'),
            icon2: require('../assets/footerbarimg/my2.png'),
            url: '/my'
          }
        ]
      } else if (footerShow && footerShow.name == 'jishi') {
        var items = [
          {
            name: '首页',
            path: '/detailspage?id=' + footerShow.id + '&footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/home.png'),
            icon2: require('../assets/footerbarimg/home2.png'),
            url: '/detailspage'
          },
          {
            name: '技师',
            url: '/technician',
            path: '/technician?serviceId=' + footerShow.id + '&footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/zhiyue.png'),
            icon2: require('../assets/footerbarimg/zhiyue2.png')
          },
          {
            name: '订单',
            path: '/allorder?footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/order.png'),
            icon2: require('../assets/footerbarimg/order2.png'),
            url: '/allorder'
          },
          {
            name: '我的',
            path: '/my?footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/my.png'),
            icon2: require('../assets/footerbarimg/my2.png'),
            url: '/my'
          }
        ]
      } else if (footerShow && footerShow.name == 'other') {
        footerShow.name == 'other'
        var items = [
          {
            name: '首页',
            url: '/?channel=lingxi',
            icon1: require('../assets/footerbarimg/home.png'),
            icon2: require('../assets/footerbarimg/home2.png'),
            path: '/?channel=lingxi'
          },
          {
            name: '订单',
            path: '/allorder?footerShow=' + JSON.stringify(footerShow) +'&?channel=lingxi',
            icon1: require('../assets/footerbarimg/order.png'),
            icon2: require('../assets/footerbarimg/order2.png'),
            url: '/allorder'
          },
          {
            name: '我的',
            path: '/my?footerShow=' + JSON.stringify(footerShow),
            icon1: require('../assets/footerbarimg/my.png'),
            icon2: require('../assets/footerbarimg/my2.png'),
            url: '/my'
          }
        ]
      } else {
        var items = [
          {
            name: '首页',
            url: '/',
            icon1: require('../assets/footerbarimg/home.png'),
            icon2: require('../assets/footerbarimg/home2.png'),
            path: '/'
          },
          {
            name: '技师',
            url: '/zhiyue',
            path: '/zhiyue',
            icon1: require('../assets/footerbarimg/zhiyue.png'),
            icon2: require('../assets/footerbarimg/zhiyue2.png')
          },
          {
            name: '订单',
            url: '/allorder',
            path: '/allorder',
            icon1: require('../assets/footerbarimg/order.png'),
            icon2: require('../assets/footerbarimg/order2.png')
          },
          {
            name: '我的',
            path: '/my',
            url: '/my',
            icon1: require('../assets/footerbarimg/my.png'),
            icon2: require('../assets/footerbarimg/my2.png')
          }
        ]
      }
      //this.items = items;
      this.$nextTick(() => {
        this.items = items;
      });
    }, 400);
  },
  methods: {
    toUrl(i) {
      if (this.footerShow && this.footerShow.name) {
        if (i == 0) {// 首页跳转下载页
          var u = navigator.userAgent;
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          if (isiOS) {
            window.location.href = 'https://www.daoway.cn/app/';
          } else {
            window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.android.daoway';
          }
        } else {
          this.$router.replace({
            path: this.items[i].path
          });
        }
      } else {
        this.$router.replace({
          path: this.items[i].url
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/footerBar.vue